import type React from "react"

import styles from "./Box.module.css"

interface BoxProps {
  title?: React.ReactNode
  titleClassname?: string
  children: React.ReactNode
  className?: string
  contentClassName?: string
  noPadding?: boolean
}

export default function Box({
  title,
  titleClassname,
  children,
  className,
  contentClassName,
  noPadding,
}: BoxProps) {
  return (
    <div
      className={`${styles.box} ${className ? className : ""} ${
        noPadding ? "p-0" : ""
      }`}
    >
      {title && (
        <h6 className={`${styles.box__title} ${titleClassname || ""}`}>
          {title}
        </h6>
      )}
      <div
        className={`${styles.box__content} ${contentClassName || ""} h-100 ${noPadding ? "p-0" : ""}`}
      >
        {children}
      </div>
    </div>
  )
}
